module.exports = __webpack_public_path__ + "media/images/sp/stores/common/visit_reservations_enpou_button-048f427046ca3b5768cc2d5bea99cb61.png";